import { reducer as asyncReducer, deleteLoadingState } from '@/helpers/async';

import previewReducer from './preview';
export {
    traverseRoute,
    handleTraverseRoute,
    setCurrentRouteProgress,
    routing_previewRide,
    routing_unpreviewRide,
    previewRide,
    openDropdown,
    updateForecast,
    previewRideCallback,
    update as updateRidePreview,
    resetScrub,
    resetCurrentRoutePoint
} from '@/store/actions/rides/preview';
import { Routes } from '@/helpers/routes';
import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import { SET_DEALER_RIDES } from '@/store/actions/rides';
import { LOCATION_CHANGE } from '@/helpers/constants';
import {
    initialState,
    partialReducer,
    DELETE_RIDE,
    FETCH_CUSTOM,
    UPDATE
} from '@/store/actions/rides';

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE: {
            const { field, value } = action.data;

            return {
                ...state,
                [field]: value
            };
        }

        case DELETE_RIDE: {
            const { id } = action.meta;
            return {
                ...state,
                custom: deleteLoadingState(id)(state.custom, action)
            };
        }

        case AUTH_INVALIDATE: {
            return {
                ...state,
                data: state.data.filter((ride) => ride.privacy === 'PUBLIC'),
                preview:
                    state.selected === null ||
                    (state.selected.privacy === 'PRIVATE' &&
                        state.selected.id !== undefined)
                        ? previewReducer(undefined, action)
                        : state.preview,
                custom: asyncReducer(FETCH_CUSTOM)(undefined, action)
            };
        }

        case SET_DEALER_RIDES:
            return { ...state, rides: action.data };

        case LOCATION_CHANGE: {
            const {
                location: { pathname }
            } = action.payload;
            const includesIdInPath =
                !!pathname &&
                pathname.indexOf(
                    (state?.selected || state?.rides?.selected || {}).shortId
                ) >= 0;
            const isRideCreatePreview =
                !!pathname && pathname.indexOf(Routes.RIDE_CREATE_PREVIEW) >= 0;
            return includesIdInPath || isRideCreatePreview
                ? state
                : { ...state, selected: null };
        }

        default: {
            return {
                ...partialReducer(state, action),
                preview: previewReducer(state.preview, action),
                custom: asyncReducer(FETCH_CUSTOM)(state.custom, action),
                ridesFiltered: state.ridesFiltered,
                ridesFilters: state.ridesFilters
            };
        }
    }
};
